import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-form-right",
  "use": "icon-form-right-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-form-right\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h36v36H0z\" /><path fill=\"#B3B3B3\" d=\"m19.758 18-7.425-7.425 2.121-2.121L24 18l-9.546 9.546-2.121-2.121z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol